<template>
  <div>
    <div class="z-popup">
      <div class="z-popup--body">
        <video id="video" preload="auto" autoplay="true" muted="muted" @pause="videoEnd">
          <source src="/media/video-bg.mp4">
        </video>
        <button class="video-close" @click="videoEnd">
          <z-icon
              type="line"
          ></z-icon>
        </button>
        <button class="video-volume" @click="triggerVolume">
          <z-icon
              type="mute"
              v-show="!isMuted"
          ></z-icon>
          <z-icon
              type="sound"
              v-show="isMuted"
          ></z-icon>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Video",
  data() {
    return {
      isMuted: true,
    }
  },
  methods: {
    videoEnd: function (){
      this.$router.replace('main')
    },
    triggerVolume: function (){
      this.isMuted = !this.isMuted;
      let video = document.getElementById('video')
      video.muted = this.isMuted;
    }
  }
}
</script>

<style scoped>

</style>